import { Component, OnInit, Input, ApplicationConfig } from '@angular/core';
import { StepDefinition } from '../dynamic';
import { FieldWrapper, FormlyFieldConfig } from '@ngx-formly/core';
import { ContextService, ServerServiceConfig } from '../../context.service';
import { HttpClient } from '@angular/common/http';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'mutara-combine-values',
  template: `<ng-container #fieldComponent></ng-container>`,
  standalone: false
})
export class CombineValuesComponent extends FieldWrapper implements OnInit {
  appDefinition: ServerServiceConfig | undefined;
  lastCheck: any;
  fieldsToWatch: FormlyFieldConfig[] = [];
  watchingFields = {};
  steps = [];
  watching = false;


  constructor(private context: ContextService, private http: HttpClient) {
    super();
  }

  get localModel(): StepDefinition[] {
    return this.props?.dataElement;
  }

  get parentGroup(): FormlyFieldConfig {
    return this.props.parentGroup;
  }
  /** 
   * Initialize the wrapper
   */
  ngOnInit() {
    // Force the parent to hide from view
    this.parentGroup.hide = true;
    // Look for fields that 
    this.parentGroup.fieldGroup?.forEach(currentField => {
      if (!!currentField.props?.mappedTo) {
        this.fieldsToWatch.push(currentField);
        let fullName = currentField.props.mappedName = currentField.props.mappedTo.match(/^(?<step>\w*)\|(?<group>\w*)\.(?<dbfield>[\w\-]*)\.{0,1}(?<field>\w*)$/)?.groups;
        currentField.props.mappedReference = !!fullName.field ? fullName.dbfield + '.' + fullName.field : fullName.dbfield;
        currentField.props.mappedStep = this.props.dataModel.find((step: StepDefinition) => {
          return step.step == fullName.step;
        });
      }
    });
    this.context.subscribeTo("applicationInfo", { next: (app : ServerServiceConfig) => this.appDefinition = app });
    this.context.subscribeTo("readyToReceive", {
      next: (isReady : boolean) => {
        if (!!isReady && this.fieldsToWatch.length > 0) {
          this.addFieldsToWatch([...this.fieldsToWatch]);
        }
      }
    });
  }
  /** 
   * After the first validity check, add the mappings for each field in the group
   */
  addFieldsToWatch(fieldStack : any[]) {
    this.fieldsToWatch = [];
    let currentField : FormlyFieldConfig;
    while (!!(currentField = fieldStack.shift())) {
      let fullName = currentField.props?.mappedName,
        fldReference = currentField.props?.mappedReference,
        sourceStep = currentField.props?.mappedStep,
        srcRef = fullName.group + '.' + fldReference;

      if (Object.keys(sourceStep.fieldMaps).length > 0) {
        if (!sourceStep.fieldMaps[fullName.group + '.' + fldReference]) {
          console.error('No target %O for %O', fullName, currentField.props?.decoratedId);
          // this.fieldsToWatch.push(currentField);
          continue;
        }
        let value = this.formState.ui.getValue(sourceStep.step, srcRef);
        // console.log('%O set initial value %O', currentField.key, value);
        currentField.props?.setValue(value, true);
        // Set the subscription once
        try {
          let fc: FormControl = sourceStep.fieldMaps[srcRef]?.formControl;
          if (!!fc) {
            if (!sourceStep.fieldMaps[srcRef].props.duplicates) {
              sourceStep.fieldMaps[srcRef].props.duplicates = [];
            }
            sourceStep.fieldMaps[srcRef].props.duplicates.push(currentField);
            sourceStep.fieldMaps[srcRef]?.form?.controls[fldReference]?.valueChanges.subscribe({
              next: (newValue : any) => {
                sourceStep.fieldMaps[srcRef].props.duplicates.forEach((dupField : FormlyFieldConfig) => {
                  dupField.props?.setValue(newValue);
                  console.log('%O %O', srcRef, newValue);
                  // currentField?.props.change(currentField);
                });
              }
            });
          } else {
            console.log('Failed %O', currentField.key);
            this.fieldsToWatch.push(currentField);
          }
        } catch (err) {
          console.error('Exception setting value %O %O', fullName, err);
          this.fieldsToWatch.push(currentField);
        }
      } else {
        // console.log('Defer %O', currentField.props.decoratedId);
        this.fieldsToWatch.push(currentField);
      }
    }
  }
}
